import { render } from "./Sidebar.vue?vue&type=template&id=d614d852&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=d614d852&scoped=true&lang=css"
import "./Sidebar.vue?vue&type=style&index=1&id=d614d852&lang=css"
script.render = render
script.__scopeId = "data-v-d614d852"

export default script